import React from "react";

const SIZE_CLASSES = {
  small: "px-3 py-1.5 text-sm",
  regular: "px-4 py-2 text-sm",
  large: "px-5 py-3 text-base",
};

const LAYOUT_CLASSES = {
  default: "bg-gray-600 text-white hover:bg-gray-700 disabled:bg-gray-400",
  outline: "border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700",
  inactive: "border border-gray-200 bg-gray-100 text-gray-500 opacity-60 cursor-not-allowed dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400",
  link: "bg-transparent text-gray-700 hover:text-gray-900 underline-offset-2 hover:underline",
  success: "bg-green-600 text-white hover:bg-green-700 disabled:bg-green-400",
  danger: "bg-red-600 text-white hover:bg-red-700 disabled:bg-red-400",
  warning: "bg-yellow-500 text-white hover:bg-yellow-600 disabled:bg-yellow-300",
  primary: "bg-blue-600 text-white hover:bg-blue-700 disabled:bg-blue-400",
};

const Button = React.forwardRef(function Button(
  {
    className = "",
    children,
    block = false,
    iconLeft,
    iconRight,
    size,
    layout,
    tag,
    href,
    disabled = false,
    onClick,
    type,
    ...rest
  },
  ref,
) {
  const Comp = tag || (href ? "a" : "button");
  const normalizedSize = SIZE_CLASSES[size] ? size : "regular";
  const normalizedLayout = LAYOUT_CLASSES[layout] ? layout : "default";

  const classes = [
    "inline-flex items-center justify-center rounded-lg font-medium transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed",
    SIZE_CLASSES[normalizedSize],
    LAYOUT_CLASSES[normalizedLayout],
    block ? "w-full" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const handleClick = (event) => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    if (onClick) onClick(event);
  };

  const componentProps = {
    ref,
    className: classes,
    onClick: handleClick,
    "aria-disabled": disabled ? "true" : undefined,
    ...rest,
  };

  if (Comp === "button") {
    componentProps.type = type || "button";
    componentProps.disabled = disabled;
  }

  if (Comp === "a") {
    componentProps.href = href;
    if (disabled) componentProps.tabIndex = -1;
  }

  const LeftIcon = iconLeft;
  const RightIcon = iconRight;

  return (
    <Comp {...componentProps}>
      {LeftIcon ? <LeftIcon className="mr-2 h-4 w-4 flex-shrink-0" aria-hidden="true" /> : null}
      {children}
      {RightIcon ? <RightIcon className="ml-2 h-4 w-4 flex-shrink-0" aria-hidden="true" /> : null}
    </Comp>
  );
});

export default Button;
